var hk = hk || {};
 
( function () {
    'use strict';
    jQuery( function () {
        hk.init();
    } );

    hk.init = function () {
        hk.iframeResizer.init();
        hk.customSearchBar.init();
        hk.megamenu.init();
        hk.supersearch.init();
        hk.convertMicroArticlesToCollapse();
        hk.ReadMoreToCollapse();
        hk.newsletterSignup.init();
        hk.jobEmbeddedVideo();
        jQuery( '.js-hk-enlarge-toggle' ).on( 'click', function () {
            jQuery( '.hk-main-content, .hk-subpage-collapse-content, .hk-main-news-content' ).toggleClass( 'enlarge-text' );
        } );
    };
    hk.iframeResizer = {};
    hk.iframeResizer.init = function () {
        var jIframe = jQuery('iframe.js-hk-iframe-resize');
        if ( jIframe.length >= 1 ) { 
            jIframe.each(function(){
                iFrameResize({
                    log: true, // Enable console logging
                    enablePublicMethods: true, // Enable methods within iframe hosted page
                    resizedCallback: function (messageData) {
                        // Callback fn when resize is received 
                        $('p#callback').html('<b>Frame ID:</b> ' + messageData.iframe.id + ' <b>Height:</b> ' + messageData.height + ' <b>Width:</b> ' + messageData.width + ' <b>Event type:</b> ' + messageData.type);
                    },
                    messageCallback: function (messageData) {
                        // Callback fn when message is received 
                        $('p#callback').html('<b>Frame ID:</b> ' + messageData.iframe.id + ' <b>Message:</b> ' + messageData.message);
                        //alert(messageData.message);
                    }
                });
            });

            jQuery( window ).on( 'load', function () {
            //jQuery( window ).on( 'resize', function () {
                //window.addEventListener('resize', function(event){
                    jIframe.each(function(){
                        var intThisIframeHeight = jQuery(this).innerHeight(),
                            intThisIframeNewHeight = intThisIframeHeight + 50;
            
                        jQuery(this).css({
                            'height': intThisIframeNewHeight,
                            'width': '99%'
                        });
                    });
                //});
            //} );
            } );
        }
    };
    hk.customSearchBar = {};
    hk.customSearchBar.init = function () {
        jQuery( '.js-custom-search-form' ).on( 'submit', function ( e ) {
            e.preventDefault();
            var customSearchBarValue = jQuery( this ).find( '.custom-search-input' ).val();
            jQuery( '.js-e-search .js-e-search-input' ).val( customSearchBarValue ).trigger( 'input' );
            jQuery( '.js-e-search' ).trigger( 'shown.bs.modal' );
        } );
        jQuery( '.js-trigger-search' ).on( 'click', function ( e ) {
            e.preventDefault();
            jQuery( '.js-custom-search-form' ).trigger( 'submit' );
        } );
    };
    hk.megamenu = {};
    hk.megamenu.init = function () {
        hk.megamenu.setShowMoreText();
    };
    hk.megamenu.setShowMoreText = function () {
        var showMoretext = jQuery( '.js-e-global-nav' ).data( 'show-more-text' );
        jQuery( '.js-show-more-text' ).text( showMoretext );
    };
    hk.supersearch = {
        init: function () {
            hk.supersearch.showMore();
        },
        showMore: function () {
            jQuery( '.js-e-search-result-pages' ).on( 'click', '.js-hk-search-webpage-item-show-more', function ( event ) {
                event.preventDefault();
                jQuery( this ).hide();
                jQuery( '.js-hk-search-webpage-item.d-none' ).hide().removeClass( 'd-none' ).fadeIn( 'fast' );
            } ).on( 'click', '.js-hk-search-news-item-show-more', function ( event ) {
                event.preventDefault();
                jQuery( this ).hide();
                jQuery( '.js-hk-search-news-item.d-none' ).hide().removeClass( 'd-none' ).fadeIn( 'fast' );
            } ).on( 'click', '.js-hk-search-employee-item-show-more', function ( event ) {
                event.preventDefault();
                jQuery( this ).hide();
                jQuery( '.js-hk-search-employee-item.d-none' ).hide().removeClass( 'd-none' ).fadeIn( 'fast' );
            } ).on( 'click', '.js-hk-search-job-item-show-more', function ( event ) {
                event.preventDefault();
                jQuery( this ).hide();
                jQuery( '.js-hk-search-job-item.d-none' ).hide().removeClass( 'd-none' ).fadeIn( 'fast' );
            } );
        }
    };
    hk.convertMicroArticlesToCollapse = function () {
        if ( jQuery( '.borgerdk-imported-content' ).length ) {
            jQuery( '.borgerdk-imported-content' ).find( '[id^=microArticle]' ).each( function ( index ) {
                var jContainer = jQuery( this ),
                    jHeadline = jContainer.find( 'h2' ),
                    jContent = jHeadline.next( 'div' ),
                    jCollapseID = jContainer.attr( 'id' );
                jContainer.addClass( 'js-borgerdk-imported-content-container borgerdk-imported-content-container' );
                jHeadline.addClass( 'p-section-toggle-collapse h3 collapsed' ).attr( 'data-target', '#collapse-' + jCollapseID ).attr( 'data-toggle', 'collapse' ).prepend( '<i class="material-icons">add</i>' );
                jContent.addClass( 'col-12 collapse' ).attr( 'id', 'collapse-' + jCollapseID );
                jContent.children().wrapAll( '<div class="hk-subpage-collapse-content"/>' );
                jContainer.removeAttr( 'id' );
            } );
            jQuery( '.js-borgerdk-imported-content-container' ).css( {
                'visibility': 'visible'
            } );
        }
    };
    hk.ReadMoreToCollapse = function () {
            jQuery( '#anbefaler' ).find( '[id^=readMore]' ).each( function ( index ) {
                var jContainer = jQuery( this ),
                    jHeadline = jContainer.find( 'h4' ),
                    jContent = jHeadline.next( 'div' ),
                    jCollapseID = jContainer.attr( 'id' );
                jContainer.addClass( 'js-borgerdk-imported-content-container borgerdk-imported-content-container' );
                jHeadline.addClass( 'p-section-toggle-collapse h3 collapsed' ).attr( 'data-target', '#collapse-' + jCollapseID ).attr( 'data-toggle', 'collapse' ).prepend( '<i class="material-icons">add</i>' );
                jContent.addClass( 'col-12 collapse' ).attr( 'id', 'collapse-' + jCollapseID );
                jContent.children().wrapAll( '<div class="hk-subpage-collapse-content"/>' );
                jContainer.removeAttr( 'id' );
            } );
            jQuery( '.js-borgerdk-imported-content-container' ).css( {
                'visibility': 'visible'
            } );
    };
    hk.newsletterSignup = {
        init: function () {
            hk.newsletterSignup.bindEvents();
            hk.newsletterSignup.validate();
        },
        bindEvents: function () {
            jQuery( '.js-hk-newsletter-areas-select' ).on( 'click', function () {
                var jForm = jQuery( this ).closest( 'form' );
                jForm.find( '.js-hk-newsletter-areas-modal' ).addClass('js-hk-newsletter-areas-modal-current').detach().prependTo( 'body' );
                jQuery( '.js-hk-newsletter-areas-modal-current' ).on( 'hide.bs.modal', function () {
                    jQuery( this ).removeClass('js-hk-newsletter-areas-modal-current').detach().appendTo( jForm );
                    var selectedCategories = jQuery( this ).find( '.js-hk-newsletter-category' ).filter( function () {
                        return jQuery( this ).is( ':checked' );
                    } );
                    jForm.find( '.js-hk-selected-newsletter-categories' ).html( '' );

                    for ( var i = 0; i < selectedCategories.length; i++ ) {
                        jForm.find( '.js-hk-selected-newsletter-categories' ).append( '<small><i class="material-icons mr-1">check</i>' + selectedCategories[ i ].dataset.name + '</small>' );
                    }
                    if ( selectedCategories.length === 0 ) {
                        jForm.find( '.js-hk-newsletter-areas-select' ).parent().find( '.js-hk-newsletter-area-select-label-off' ).prop( 'hidden', false );
                        jForm.find( '.js-hk-newsletter-areas-select' ).parent().find( '.js-hk-newsletter-area-select-label-on' ).prop( 'hidden', true );
                    }
                    else {
                        jForm.find( '.js-hk-newsletter-areas-select' ).parent().find( '.js-hk-newsletter-area-select-label-off' ).prop( 'hidden', true );
                        jForm.find( '.js-hk-newsletter-areas-select' ).parent().find( '.js-hk-newsletter-area-select-label-on' ).prop( 'hidden', false );
                        jForm.find( '.hk-custom-category-select' ).find( '.js-e-form-validation-msg' ).addClass( 'd-none' );

                    }
                } ).modal();
            } );
        },
        validate: function () {
            jQuery( '.js-hk-newsletter-signup' ).find( 'button[type="submit"]' ).on( 'click', function ( event ) {
                event.preventDefault();
                var jForm = jQuery( this ).closest( 'form' );
                if ( jForm.find( '.js-hk-newsletter-category:checkbox:checked' ).length > 0 ) {
                    jForm.find( '.hk-custom-category-select' ).find( '.js-e-form-validation-msg' ).text( '' ).addClass( 'd-none' );
                    jForm.submit();
                }
                else {
                    jForm.find( '.hk-custom-category-select' ).find( '.js-e-form-validation-msg' ).text( jForm.find( '.hk-custom-category-select' ).find( '.js-e-form-validation-msg' ).data( 'error-msg' ) ).removeClass( 'd-none' );
                }

            } );
        }
    };
    hk.jobEmbeddedVideo = function () {
        var HKJobVideoUrl = jQuery( 'video-link' ).attr( 'video-url' );
        if( HKJobVideoUrl.indexOf( 'youtube') !== -1 ) {
            var HKJobVideoUrlEmbeddedYoutube = HKJobVideoUrl.replace( 'watch?v=', 'embed/' );

            var HKJobVideoTempEmbeddedCodeYoutube =
                "<div class='embed-responsive embed-responsive-16by9'>" +
                "<iframe class='embed-responsive-item' type='text/html' width='720' height='405' src='videoUrlEmbed' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>" +
                "</div>";
            var HKJobVideoEmbeddedCodeYoutube = HKJobVideoTempEmbeddedCodeYoutube.replace( 'videoUrlEmbed', HKJobVideoUrlEmbeddedYoutube );

            jQuery( 'video-link' ).replaceWith( HKJobVideoEmbeddedCodeYoutube );
        }
        if( HKJobVideoUrl.indexOf( 'youtube' ) !== -1 ) {
            var HKJobVideoUrlEmbeddedVimeo = HKJobVideoUrl.replace( '//vimeo.com/', '//player.vimeo.com/video/' );

            var HKJobVideoTempEmbeddedCodeVimeo =
                "<div class='embed-responsive embed-responsive-16by9'>" +
                "<iframe class='embed-responsive-item' title='vimeo-player' src='videoUrlEmbed' width='640' height='360' frameborder='0' allowfullscreen></iframe>" +
                "</div>";
            var HKJobVideoEmbeddedCodeVimeo = HKJobVideoTempEmbeddedCodeVimeo.replace( 'videoUrlEmbed', HKJobVideoUrlEmbeddedVimeo );

            jQuery( 'video-link' ).replaceWith( HKJobVideoEmbeddedCodeVimeo );
        } 
    };
}() );
